import { render, staticRenderFns } from "./SaleTagForm.vue?vue&type=template&id=6b7579bb&scoped=true"
import script from "./SaleTagForm.vue?vue&type=script&lang=js"
export * from "./SaleTagForm.vue?vue&type=script&lang=js"
import style0 from "./SaleTagForm.vue?vue&type=style&index=0&id=6b7579bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7579bb",
  null
  
)

export default component.exports